import FormSMS from './FormSMS';

export default FormSMS;



// WEBPACK FOOTER //
// ./src/components/Login/FormSMS/index.js